"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LabeledInput = _interopRequireDefault(require("../../Inputs/LabeledInput"));

var _LinkButton = _interopRequireDefault(require("../../Buttons/LinkButton"));

var _Form = _interopRequireDefault(require("../../FormElements/Form"));

var _FormRow = _interopRequireDefault(require("../../FormElements/FormRow"));

var _ParagraphText = _interopRequireDefault(require("../../TextElements/BasicTextElements/ParagraphText"));

var _Button = _interopRequireDefault(require("../../Buttons/Button"));

var _LabelText = _interopRequireDefault(require("../../TextElements/BasicTextElements/LabelText"));

var _AdressManualForm = require("./AdressManualForm.styles");

var _strings = _interopRequireWildcard(require("../../../constants/strings"));

var _validationRules = require("../../../constants/validation/validationRules");

var _displayModes = require("../../../constants/displayModes");

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _idGenerator = _interopRequireDefault(require("../../../utils/idGenerator"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AddressManualForm = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AddressManualForm, _React$PureComponent);

  var _super = _createSuper(AddressManualForm);

  function AddressManualForm(props) {
    var _this;

    _classCallCheck(this, AddressManualForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "clearAddress", function () {
      _this.setState({
        city: '',
        state: '',
        street: '',
        unitNumber: '',
        zipcode: ''
      }, _this.handleHoistFormValues);
    });

    _defineProperty(_assertThisInitialized(_this), "handleHoistFormValues", function () {
      return _this.props.hoistFormValues && _this.props.hoistFormValues(_this.state);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var _e$target = e.target,
          name = _e$target.name,
          value = _e$target.value;

      _this.setState(_defineProperty({}, name, value), _this.handleHoistFormValues);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (e) {
      e.preventDefault();

      _this.props.onSubmit(_this.state);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEditMode", function () {
      _this.setState({
        mode: _this.state.mode === _displayModes.displayModes.editing ? _displayModes.displayModes.viewing : _displayModes.displayModes.editing
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFields", function () {
      var _this$state = _this.state,
          city = _this$state.city,
          state = _this$state.state,
          street = _this$state.street,
          unitNumber = _this$state.unitNumber,
          zipcode = _this$state.zipcode;
      var _this$props = _this.props,
          addressInputLabel = _this$props.addressInputLabel,
          omitUnitNumberField = _this$props.omitUnitNumberField;
      var cityLabel = _strings.default.cityLabel,
          stateLabel = _strings.default.stateLabel,
          unitNumberLabel = _strings.default.unitNumberLabel,
          zipcodeLabel = _strings.default.zipcodeLabel;
      var fields = [/*#__PURE__*/_react.default.createElement(_FormRow.default, {
        key: "street"
      }, /*#__PURE__*/_react.default.createElement(_LabeledInput.default, {
        characterLimit: 80,
        dataTestId: "address-manual-form-street",
        id: "street-input-".concat(_this.formId),
        inputType: "text",
        label: "".concat(addressInputLabel, ":"),
        name: "street",
        onChange: _this.handleChange,
        value: street,
        validationRules: {
          BLUR: [_validationRules.REQUIRED],
          // CHANGE: [REQUIRED],
          SUBMIT: [_validationRules.REQUIRED]
        }
      })), !omitUnitNumberField ? /*#__PURE__*/_react.default.createElement(_FormRow.default, {
        key: "unit"
      }, /*#__PURE__*/_react.default.createElement(_LabeledInput.default, {
        characterLimit: 30,
        dataTestId: "address-manual-form-unit-number",
        id: "unit-input-".concat(_this.formId),
        inputType: "text",
        label: "".concat(unitNumberLabel, ":"),
        name: "unitNumber",
        onChange: _this.handleChange,
        value: unitNumber
      })) : null, /*#__PURE__*/_react.default.createElement(_FormRow.default, {
        key: "city"
      }, /*#__PURE__*/_react.default.createElement(_LabeledInput.default, {
        characterLimit: 40,
        dataTestId: "address-manual-form-city",
        id: "city-input-".concat(_this.formId),
        inputType: "text",
        label: "".concat(cityLabel, ":"),
        name: "city",
        onChange: _this.handleChange,
        value: city,
        validationRules: {
          BLUR: [_validationRules.REQUIRED],
          // CHANGE: [REQUIRED],
          SUBMIT: [_validationRules.REQUIRED]
        }
      })), /*#__PURE__*/_react.default.createElement(_FormRow.default, {
        key: "stateZip"
      }, /*#__PURE__*/_react.default.createElement(_LabeledInput.default, {
        dataTestId: "address-manual-form-state",
        id: "state-input-".concat(_this.formId),
        inputType: "state",
        label: "".concat(stateLabel, ":"),
        name: "state",
        onChange: _this.handleChange,
        value: state,
        validationRules: {
          BLUR: [_validationRules.REQUIRED, _defineProperty({}, _validationRules.MINIMUM_CHARACTERS, 2), _defineProperty({}, _validationRules.MAXIMUM_CHARACTERS, 2)],
          // CHANGE: [REQUIRED],
          SUBMIT: [_validationRules.REQUIRED, _defineProperty({}, _validationRules.MINIMUM_CHARACTERS, 2), _defineProperty({}, _validationRules.MAXIMUM_CHARACTERS, 2)]
        }
      }), /*#__PURE__*/_react.default.createElement(_LabeledInput.default, {
        characterLimit: 5,
        dataTestId: "address-manual-form-zip-code",
        id: "zipcode-input-".concat(_this.formId),
        inputType: "zipcode",
        label: "".concat(zipcodeLabel, ":"),
        name: "zipcode",
        onChange: _this.handleChange,
        value: zipcode,
        validationRules: {
          BLUR: [_validationRules.REQUIRED, _defineProperty({}, _validationRules.MINIMUM_CHARACTERS, 5), _defineProperty({}, _validationRules.MAXIMUM_CHARACTERS, 5)],
          // CHANGE: [REQUIRED],
          SUBMIT: [_validationRules.REQUIRED, _defineProperty({}, _validationRules.MINIMUM_CHARACTERS, 5), _defineProperty({}, _validationRules.MAXIMUM_CHARACTERS, 5)]
        }
      }))];
      return fields.filter(Boolean);
    });

    _defineProperty(_assertThisInitialized(_this), "renderViewForm", function () {
      var _this$props2 = _this.props,
          className = _this$props2.className,
          dataTestId = _this$props2.dataTestId,
          viewModeLabel = _this$props2.viewModeLabel;
      var _this$state2 = _this.state,
          city = _this$state2.city,
          state = _this$state2.state,
          street = _this$state2.street,
          unitNumber = _this$state2.unitNumber,
          zipcode = _this$state2.zipcode;
      return /*#__PURE__*/_react.default.createElement(_AdressManualForm.StyledViewForm, {
        className: className,
        "data-test-id": "".concat(dataTestId, "-view-mode")
      }, /*#__PURE__*/_react.default.createElement(_LabelText.default, {
        className: "c-address-manual-form-label",
        dataTestId: "address-manual-form-view-label"
      }, viewModeLabel), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-address-manual-form-read-only-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-address-manual-form-view-text-rapper"
      }, /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
        className: "c-address-manual-form-view-text",
        dataTestId: "address-manual-form-view-street-and-unit"
      }, street, unitNumber && ",\xA0\xA0".concat(unitNumber)), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
        className: "c-address-manual-form-view-text",
        dataTestId: "address-manual-form-view-city-state-zip"
      }, city, ",", state, zipcode)), /*#__PURE__*/_react.default.createElement(_LinkButton.default, {
        dataTestId: "address-manual-form-edit-button",
        className: "c-address-manual-form-edit-button",
        isBlock: true,
        onClick: _this.toggleEditMode
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        dataTestId: "input-edit-icon",
        iconName: "pencil-alt",
        colorTheme: "primary"
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderEditForm", function () {
      var _this$props3 = _this.props,
          buttonChildren = _this$props3.buttonChildren,
          buttonProps = _this$props3.buttonProps,
          className = _this$props3.className,
          clearable = _this$props3.clearable,
          dataTestId = _this$props3.dataTestId,
          isEmbedded = _this$props3.isEmbedded,
          title = _this$props3.title;

      if (isEmbedded) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: className
        }, _this.renderFields());
      }

      return /*#__PURE__*/_react.default.createElement(_Form.default, {
        className: className,
        dataTestId: "".concat(dataTestId, "-edit-mode"),
        id: "manual-address-form-".concat(_this.formId)
      }, clearable || title ? /*#__PURE__*/_react.default.createElement(_AdressManualForm.TitleBar, {
        dataTestId: "address-manual-form-title-bar",
        className: "c-address-manual-form-title-bar"
      }, /*#__PURE__*/_react.default.createElement(_AdressManualForm.StyledTitle, {
        dataTestId: "address-manual-form-title",
        className: "c-address-manual-form-title"
      }, title), clearable && /*#__PURE__*/_react.default.createElement(_LinkButton.default, {
        dataTestId: "address-manual-form-clear-button",
        className: "c-address-manual-form-clear-button",
        onClick: _this.clearAddress
      }, "Clear")) : null, _this.renderFields(), /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, buttonProps, {
        buttonType: "submit",
        key: "submitButton",
        dataTestId: "address-manual-form-submit-button",
        onClick: _this.handleSubmit
      }), buttonChildren));
    });

    _this.state = {
      city: props.values.city,
      state: props.values.state,
      street: props.values.street,
      unitNumber: props.values.unitNumber,
      zipcode: props.values.zipcode,
      mode: props.mode
    };
    _this.formId = (0, _idGenerator.default)();
    return _this;
  }

  _createClass(AddressManualForm, [{
    key: "render",
    value: function render() {
      var mode = this.state.mode;
      return mode === _displayModes.displayModes.viewing ? this.renderViewForm() : this.renderEditForm();
    }
  }]);

  return AddressManualForm;
}(_react.default.PureComponent);

_defineProperty(AddressManualForm, "propTypes", {
  /** Label for the Street/Address field, i.e. the topmost input */
  addressInputLabel: _propTypes.default.string,

  /** Children to inject into the button displayed when the address form is not nested in another form */
  buttonChildren: _propTypes2.default.children,

  /** Pass-through props for the button displayed when the address form is not nested in another form.
   * See Button component details on available props.
   */
  buttonProps: _propTypes.default.shape(),

  /** Styling override */
  className: _propTypes.default.string,

  /** Adds a clear button */
  clearable: _propTypes.default.bool,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** hoisting function for form values */
  hoistFormValues: _propTypes.default.func.isRequired,

  /** flag used to indicate that the address form is nested in a larger form structure */
  isEmbedded: _propTypes.default.bool,

  /** Prop to conditionally remove unit number field */
  omitUnitNumberField: _propTypes.default.bool,

  /** mode flag - 'viewOnly', 'viewing' or 'editOnly' */
  mode: _propTypes.default.oneOf([undefined, _displayModes.displayModes.viewOnly, _displayModes.displayModes.viewing, _displayModes.displayModes.editOnly]),

  /** standard onSubmit hook */
  onSubmit: _propTypes.default.func,

  /** Form Title */
  title: _propTypes.default.string,

  /** address object */
  values: _propTypes.default.shape({
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    street: _propTypes.default.string,
    unitNumber: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    zipcode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  }),
  viewModeLabel: _propTypes.default.string
});

_defineProperty(AddressManualForm, "defaultProps", {
  addressInputLabel: _strings.default.addressInputLabel,
  buttonChildren: _strings.defaultSubmitText,
  buttonProps: {},
  className: '',
  clearable: false,
  isEmbedded: false,
  mode: _displayModes.displayModes.editOnly,
  omitUnitNumberField: false,
  onSubmit: function onSubmit() {},
  title: '',
  values: {
    city: '',
    state: '',
    street: '',
    unitNumber: '',
    zipcode: ''
  },
  viewModeLabel: _strings.defaultAddressFormViewLabel
});

var _default = AddressManualForm;
exports.default = _default;